<template>
  <div class="table-responsive">
    <div class="alert alert-info" role="alert" v-if="data.length === 0">
      {{ $t('No data') }}
    </div>

    <table class="table table-lightborder" v-else>
      <thead>
        <tr>
          <th>
            {{ $t('Time Interval') }}
          </th>
          <th>
            {{ $t('Product Code') }}
          </th>
          <th>
            {{ $t('Description') }}
          </th>
          <th class="text-right">
            {{ $t('Unblended Cost') }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td class="td-time">
            <div>
              {{ splitTimeIntervalStart(item['identity/TimeInterval']) }}
            </div>
            <div>~</div>
            <div>
              {{ splitTimeIntervalEnd(item['identity/TimeInterval']) }}
            </div>
          </td>
          <td>
            {{ item['lineItem/ProductCode'] }}
          </td>
          <td class="td-desc">
            {{ item['lineItem/LineItemDescription'] }}
          </td>
          <td class="td-cost text-right">
            {{ item['lineItem/UnblendedCost'] | currencyAmount }}
            <span class="smaller lighter">({{ item['lineItem/CurrencyCode'] }})</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { basic } from '@/lib/dates';

const messages = {
  en: {
    'Time Interval': 'Period',
    Description: 'Description',
    'Product Code': 'Product Code',
    'Unblended Cost': 'Unblended Cost',
    'No data': 'No data',
  },
  ja: {
    'Time Interval': '期間',
    Description: '説明',
    'Product Code': 'プロダクトコード',
    'Unblended Cost': 'コスト',
    'No data': 'データがありません。',
  },
};

export default {
  name: 'FeesTable',
  i18n: { messages },
  props: {
    data: { type: Array, default: () => [] },
  },
  methods: {
    splitTimeIntervalStart(val) {
      const start = val.split('/');
      if (!start[0]) return '-';
      return basic(start[0]);
    },

    splitTimeIntervalEnd(val) {
      const start = val.split('/');
      if (!start[1]) return '-';
      return basic(start[1]);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  min-height: 300px;
  max-height: 450px;
  overflow: auto;
}

.table {
  width: 100%;
}

thead {
  tr {
    th {
      padding-right: 1rem;
      font-size: 0.8rem;
      text-transform: uppercase;
      border-top: none;
    }
    th:last-child {
      padding-right: 0rem;
    }
  }
}

tbody {
  max-height: 600px;
  overflow-y: scroll;

  tr {
    .td-time {
      min-width: 150px;
    }

    .td-cost {
      min-width: 110px;
    }

    td {
      padding-right: 1rem;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      font-size: 0.8rem;
      border-top: 1px solid $border-color;
    }
    td:last-child {
      padding-right: 0rem;
    }
  }
}
</style>
